import React, { useEffect } from "react";
import { useState } from "react"
import "./about.css"
import "./faq.css"
import { data } from "../servicesData";
import BEE from "./BEE";
import FAQ from "./FAQ";
import myImage from '../assets/images/clients/Picture 1.png';
import { imageData } from "../assets/images/clients/clientGallery"
// import video from "../assets/images/long-video-background.mp4";

export default function About() {

    const [viewServices, setViewServices] = useState({
        service1: {
            display: true,
            content: data.services[0].content,
            title: data.services[0].title
        },
        service2: {
            display: false,
            title: data.services[1].title,
            content: data.services[1].content
        },
        service3: {
            display: false,
            title: data.services[2].title,
            content: data.services[2].content
        },
        service4:  {
            display: false,
            title: data.services[3].title,
            content: data.services[3].content
        },
        service5: {
            display: false,
            title: data.services[4].title,
            content: data.services[4].content
        },
        service6: {
            display: false,
            title: data.services[5].title,
            content: data.services[5].content
        },
    })

    const [content, setContent] = useState(data.services[0].content)
    const [title, setTitle] = useState(data.services[0].title)
    const [moreContent, setMoreContent] = useState([])

    const moreContentRender = moreContent.map((data) => {
        return (
            <div className="moreContent">
                <h3 className="moreContent-title">
                    {data.title}
                </h3>
                <p className="service-text">
                    {data.content}
                </p>
            </div>
        )
    })

    const toggleServices = (e) => {
        const active = e.target.id;
        console.log(active)
     
        setViewServices(prevState => {
          const newState = {...prevState};
            for (const key in prevState) {
            newState[key].display = false;
            }
            newState[active].display = true
            
          return {
            ...newState
          };
        });
        console.log(viewServices)
        setContent(viewServices[active].content)
        setTitle(viewServices[active].title)

        console.log(moreContent)
    }

    

    useEffect(() => {
        if (viewServices.service1.display) {
            setMoreContent(data.services[0].more)
        } else if (viewServices.service2.display) {
            setMoreContent(data.services[1].more)
        }
        else {
            setMoreContent([])
        }
        },
        [viewServices, content])
    
    const imagesArr = imageData.images
    const clients = imagesArr.map((image, index) => {
        return (
        <li key={image.key} className="box">
            <img src={image.img} alt="" id={index}/>
        </li>
        )
    })


    return (
        <div className="about">

            <div className="mission-wrapper">
                <div className="mission-text-wrapper">
                    <h2 className="mission-title">Our Story</h2><br />
                    <p className="mission-text">
                        At Pillar South Africa, we stand tall as a pioneering force in the realms of staffing and administration since our establishment in 2018. <br/><br/>

                        Pillar South Africa offers premium Staffing Solutions along with a variety of complementary services that may support or enhance your already existing Human Resource function. We staff the best professionals, backed with solid years of expertise and experience, who can integrate solutions that advance the best interest of your organisation.<br/><br/>

                        We have 100% record for positions filled, a serious commitment to customer services with an equally efficient 24-hour turnaround time on almost every request. <br/><br/>

                        As a premier firm, Pillar South Africa has been at service to clients in the private and public sector alike, giving us thorough experience to navigate various business industries.<br/><br/>

                        Our business structure is fully compliant as a Level 1 BEE contributor being a 100% female black owned and a VAT registered business. 

                    </p>
                    <div className="mission-signature mission-text">
                        {/* - Director, Pillar South Africa */}
                    </div>
                </div>
            </div>

            <div className="services-wrapper section">
                <div className="placement-bg"></div>
                <div className="services-viewer ">

                    <div className="service-content">

                        <p className="service-text">
                            {content}
                        </p>

                    </div>
                    
                    <div className="service-text-wrapper ">
                    
                        <div className={"service left" + (viewServices.service1.display ? " full-size" : " minimized-size" )}>
                            <div className="service-subtitle-wrapper">
                                <h3 className="service-subtitle"
                                    id="service1"
                                    onClick={toggleServices}
                                >Staffing</h3>
                            </div>                       
                        </div>

                        <div className={"service center" + (viewServices.service2.display ? " full-size" : " minimized-size" )}>
                            <div className="service-subtitle-wrapper">
                                <h3 className="service-subtitle"
                                    onClick={toggleServices}
                                    id="service2"
                                >Labour Brokerage and Outsourcing</h3>
                            </div>
                                        
                        </div>

                        <div className={"service right" + (viewServices.service3.display ? " full-size" : " minimized-size" )}>
                            <div className="service-subtitle-wrapper">
                                <h3 className="service-subtitle"
                                    id="service3"
                                    onClick={toggleServices}
                                >Human Resources</h3>
                            </div>
                        </div>
                        
                    </div>

                </div>
            
            </div>



            <BEE />
            <div className="quote-wrapper">
                <h1 className="quote">
                "Pillars add strength and integrity to a building.
                In structural engineering, pillars support heavy loads above them."
                </h1>
            </div>
            
            <div className="faq section">

                <div className="faq-wrapper">
                    <div className="faq-content">
                        <div className="faq-title-wrapper">
                            <h2 className="mission-title">
                                Our Clients
                            </h2>
                        </div>
                        <ul className="partners-grid">
                            {clients}
                        </ul>
                    </div>
                </div>

                <div className="faq-wrapper">

                    <div className="faq-content">
                        <div className="faq-title-wrapper">
                            <h2 className="mission-title">
                                Frequently Asked Questions
                            </h2>
                        </div>

                        <FAQ />

    
                    </div>
                </div>

            </div>
        </div>
    )
}